// extracted by mini-css-extract-plugin
export default {"footer":"FooterAdmin_footer__3bhmh","footer__links":"FooterAdmin_footer__links__Uni6T","footer__links-item-label":"FooterAdmin_footer__links-item-label__HIzoo"};